import { Paper, Stack, Typography } from "@mui/material"
import React from "react"

export const BaseTitleBox = ({variant = 4, title, icon, minWidth, align, sx }) => {
    const p = 1 + (5 - variant) * 0.2 
    const iconDef = {
        sx: {
            transform: `scale(${p*2})`,
        }
    }

    return (
        <Paper variant="outlined" sx={{ p: p*4, pl: p*4, pr: p*4, backgroundColor: '#aaaaaa50', minWidth: minWidth && minWidth, ...sx }}>
        <Stack sx={{ width: '100%', height: '100%' }}
            direction="row"
            justifyContent={align === 'center' ? 'center' : 'stretch'}
            alignItems="center"
            spacing={p*2}>
            {icon && React.cloneElement(icon, iconDef)}
            <Typography variant={`h${variant}`}>{title}</Typography>
        </Stack>
        </Paper>
    )
}
export default BaseTitleBox